import { Link } from 'react-router-dom';

export default function CFIsHero() {
  return (
    <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ea6350d8f1676b9c43bfae264edbf6d7.jpg"
          alt="Flight instructor training"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A1628]/85 via-[#0A1628]/75 to-[#0A1628]"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#00FFD1]/10 border border-[#00FFD1]/30 mb-6">
          <i className="ri-shield-check-line text-[#00FFD1] text-lg"></i>
          <span className="text-sm text-[#00FFD1] font-medium uppercase tracking-wider">For Certified Flight Instructors</span>
        </div>

        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
          Elevate Your <span className="text-[#00FFD1]">Instruction</span>
        </h1>

        <p className="text-xl md:text-2xl text-gray-300 mb-4 max-w-3xl mx-auto leading-relaxed">
          Empower your students with data-driven insights, streamline debriefs, and track progress like never before.
        </p>

        <p className="text-base md:text-lg text-gray-400 mb-10 max-w-2xl mx-auto">
          WingmanFix gives you the tools to deliver world-class instruction—backed by AI-powered flight analysis, real-time scoring, and comprehensive student progress tracking.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/waitlist"
            className="group px-8 py-4 bg-[#00FFD1] text-[#0A1628] rounded-lg font-semibold text-base hover:bg-[#00FFD1]/90 transition-all duration-300 flex items-center gap-2 shadow-lg shadow-[#00FFD1]/20 hover:shadow-[#00FFD1]/40 whitespace-nowrap cursor-pointer"
          >
            Join Waitlist
            <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform"></i>
          </Link>

          <Link
            to="/features"
            className="px-8 py-4 bg-transparent border-2 border-[#00FFD1] text-[#00FFD1] rounded-lg font-semibold text-base hover:bg-[#00FFD1]/10 transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-eye-line text-lg"></i>
            View Features
          </Link>
        </div>

        {/* Stats Bar */}
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-3xl mx-auto">
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-[#00FFD1] mb-2">340+</div>
            <div className="text-sm text-gray-400 uppercase tracking-wider">Pilots on Waitlist</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-[#00FFD1] mb-2">50+</div>
            <div className="text-sm text-gray-400 uppercase tracking-wider">CFIs Testing Beta</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-[#00FFD1] mb-2">1,200+</div>
            <div className="text-sm text-gray-400 uppercase tracking-wider">Flights Analyzed</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-[#00FFD1] text-2xl"></i>
      </div>
    </section>
  );
}